import * as Sentry from "@sentry/react";

// Only initialize sentry if not localhost
if (import.meta.env.VITE_SENTRY_AUTH_TOKEN) {
    Sentry.init({
        dsn: "https://053e006e246bb019c042dd6b003654e1@o941761.ingest.us.sentry.io/4509325590986752",
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
            Sentry.rewriteFramesIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            /* "localhost", */
            /^https:\/\/ai\.dib\.no\/api/,
            /^https:\/\/ai\.dibdev\.no\/api/,
        ],
        ignoreErrors: ["TypeError: Failed to fetch"],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        beforeSend(event, hint) {
            if (event.extra && typeof event.extra.__serialized__ === "object") {
                const serialized = event.extra.__serialized__ as any;

                // Check for the direct string error
                if (serialized.error === "TypeError: Failed to fetch") {
                    return null;
                }

                // Check for nested error object structure - handle both string and Error object
                if (
                    serialized.error?.error === "TypeError: Failed to fetch" ||
                    serialized.error?.error?.toString() ===
                        "TypeError: Failed to fetch" ||
                    serialized.error?.status === "FETCH_ERROR"
                ) {
                    return null;
                }

                // Check for status codes at both root and error object level
                if (
                    serialized.status === 401 ||
                    serialized.error?.status === 401
                ) {
                    return null;
                }
            }

            return event;
        },
        // end very important config
    });
}

console.log(
    "App version: ",
    import.meta.env.VITE_SENTRY_RELEASE_NAME || "local"
);
